import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PackageSearch, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import { formatFCFA, formatDate } from "@/lib/format";
import { Loader, EmptyState, StatusBadge } from "@/components/common";
import { ORDER_STATUS } from "@/lib/labels";

export default function OrdersPage() {
  const [orders, setOrders] = useState(null);
  useEffect(() => { api.get("/orders").then((r) => setOrders(r.data)); }, []);
  if (!orders) return <Loader />;

  if (orders.length === 0)
    return <EmptyState icon={PackageSearch} title="Aucune commande" subtitle="Vos commandes apparaîtront ici."
      action={<Link to="/recherche" className="bg-[#C85A32] text-white font-bold px-5 py-2.5 rounded-lg">Explorer le catalogue</Link>} />;

  return (
    <div>
      <h1 className="font-display text-3xl font-extrabold text-[#0F172A] mb-5">Mes commandes</h1>
      <div className="space-y-3">
        {orders.map((o) => (
          <Link key={o.id} to={`/commandes/${o.id}`} data-testid={`order-row-${o.id}`}
            className="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-3 hover:border-[#C85A32]/40 hover:shadow-sm transition">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-num font-bold text-slate-800">{o.order_number}</span>
                <StatusBadge map={ORDER_STATUS} value={o.status} />
              </div>
              <p className="text-xs text-slate-500 mt-1">{formatDate(o.created_at)} · {o.items.length} article(s) · {o.zone}</p>
            </div>
            <div className="text-right shrink-0">
              <p className="font-num font-bold text-[#C85A32]">{formatFCFA(o.total)}</p>
            </div>
            <ChevronRight className="w-5 h-5 text-slate-300" />
          </Link>
        ))}
      </div>
    </div>
  );
}
